export default "__VITE_ASSET__DKMG4lWa__"